import {domains} from '../../constants/Utils';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';
import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';
import {claimsWebsocketCommands} from '../../constants/claimsWebsocketCommands';

export const ADMIN_NOTIFICATION_FETCH_PENDING = 'ADMIN_NOTIFICATION_FETCH_PENDING';
export const ADMIN_NOTIFICATION_UPDATE = 'ADMIN_NOTIFICATION_UPDATE';
export const ADMIN_NOTIFICATION_SELECT_GROUP = 'ADMIN_NOTIFICATION_SELECT_GROUP';

export const storeSelectedCountryGroup = countryGroup => dispatch =>
    dispatch({
        type: ADMIN_NOTIFICATION_SELECT_GROUP,
        payload: countryGroup
    });

export const fetchNotificationData = (domain, group) => dispatch => {
    switch (domain) {
        case domains.SPARE_PARTS: {
            return dispatch({
                type: ADMIN_NOTIFICATION_FETCH_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_NOTIFICATIONS_GET,
                payload: {group}
            });
        }
        case domains.TECHNICAL_DOCUMENTATION: {
            return dispatch({
                type: ADMIN_NOTIFICATION_FETCH_PENDING,
                techDocWebsocket: true,
                command: techDocWebsocketCommands.TECH_DOC_NOTIFICATIONS_GET,
                payload: {group}
            });
        }
        case domains.CLAIMS: {
            return dispatch({
                type: ADMIN_NOTIFICATION_FETCH_PENDING,
                claimsWebsocket: true,
                command: claimsWebsocketCommands.CLAIMS_NOTIFICATIONS_GET,
                payload: {group}
            });
        }
    }
};

export const updateNotificationData = (domain, group, {subject, body}) => dispatch => {
    switch (domain) {
        case domains.SPARE_PARTS: {
            return dispatch({
                type: ADMIN_NOTIFICATION_UPDATE,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_NOTIFICATIONS_SET,
                payload: {notification: {group, subject, body}}
            });
        }
        case domains.TECHNICAL_DOCUMENTATION: {
            return dispatch({
                type: ADMIN_NOTIFICATION_UPDATE,
                techDocWebsocket: true,
                command: techDocWebsocketCommands.TECH_DOC_NOTIFICATIONS_SET,
                payload: {notification: {group, subject, body}}
            });
        }
        case domains.CLAIMS: {
            return dispatch({
                type: ADMIN_NOTIFICATION_UPDATE,
                claimsWebsocket: true,
                command: claimsWebsocketCommands.CLAIMS_NOTIFICATIONS_SET,
                payload: {notification: {group, subject, body}}
            });
        }
    }
};

